module.exports = __webpack_public_path__ + "img/doe-logo-bw-lg.6d7de76e.png";